import axios from 'axios'
import {PaginateModel} from '../../../shared/models/PaginateModel'
import {SchedulerModel} from '../models/SchedulerModel'
import {CreateSchedulerRequestModel} from '../models/CreateSchedulerRequestModel'
import {cleanupPaginationParams} from '../../../shared/utils'

const API_URL = process.env.REACT_APP_API_URL
export const SCHEDULER_BASE_URL = `${API_URL}/sync-order-scheduler`

export function getAllUserSchedulerSetting(params: PaginateModel) {
  return axios.get(SCHEDULER_BASE_URL + '/schedulers/settings', {
    params: cleanupPaginationParams(params),
  })
}

export function getAllUserSchedulerLogs(params: PaginateModel) {
  return axios.get(SCHEDULER_BASE_URL + '/schedulers', {
    params: cleanupPaginationParams(params),
  })
}

export function downloadDocument(transactionId: number) {
  return axios.get(SCHEDULER_BASE_URL + '/' + transactionId + '/get-document')
}

export function verifyDriveFolder(folderId: string) {
  return axios.post(SCHEDULER_BASE_URL + '/folder-verify', {
    folderId,
  })
}
export function createSchedulerSetting(data: CreateSchedulerRequestModel) {
  return axios.post(SCHEDULER_BASE_URL + '/schedulers/settings', data)
}

export function updateSchedulerSetting(data: SchedulerModel) {
  return axios.put(SCHEDULER_BASE_URL + '/schedulers/settings', data)
}
export function trySchedulerSettingFolder(folderName: string, schedulerId: string) {
  return axios.post(SCHEDULER_BASE_URL + '/try', {
    name: folderName,
    userSchedulerSettingId: schedulerId,
  })
}
export function updateSchedulerSettingStatusById(id: number, status: string) {
  return axios.put(SCHEDULER_BASE_URL + '/schedulers/settings/' + id + '/status', {
    status: status,
  })
}
export function deleteSchedulerSettingById(id: number) {
  return axios.put(SCHEDULER_BASE_URL + '/schedulers/settings/delete', {
    ids: [id],
  })
}

export function getAllSchedulerOrderList(scheduleId: string, params: PaginateModel) {
  return axios.get(SCHEDULER_BASE_URL + '/schedulers/' + scheduleId + '/orders', {
    params,
  })
}
